module.exports = __webpack_public_path__ + "img/375.7ff7cad0.jpg";